/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';

import TableItemMobile from '../TableItemMobile';
import TableSummary from '../TableSummary';

import BackButton from './styled';

export const TableMobile = ({
    order,
    changeItemQuantity,
    removeItem,
    readOnly,
    displaySummaryNote,
    children,
}) => (
    <div>
        {(order.items || []).map((product) => (
            <TableItemMobile
                changeItemQuantity={(quantity) => changeItemQuantity(product, quantity)}
                removeItem={() => removeItem(product)}
                readOnly={readOnly}
                orderCurrencySymbol={order.currencySymbol}
                product={product}
                single={order.items.length === 1}
                key={product.id}
            />
        ))}
        <TableSummary
            orderCurrencySymbol={order.currencySymbol}
            orderSubtotal={order.item_total}
            orderShipping={order.shipment_total}
            orderVoucherDiscount={order.voucher && order.voucher.discount}
            orderTotal={order.total}
            orderDiscount={order.discount_total}
            orderTax={order.us_sales_tax}
            displaySummaryNote={displaySummaryNote}
            mobile
        />
        <BackButton>{children}</BackButton>
    </div>
);

TableMobile.propTypes = {
    order: PropTypes.shape({}).isRequired,
    changeItemQuantity: PropTypes.func,
    removeItem: PropTypes.func,
    readOnly: PropTypes.node,
    displaySummaryNote: PropTypes.bool,
    children: PropTypes.node,
};

TableMobile.defaultProps = {
    changeItemQuantity: () => {},
    removeItem: () => {},
    readOnly: undefined,
    displaySummaryNote: false,
    children: undefined,
};

export default TableMobile;
